import React, { Component } from "react";
import styled from "styled-components";

import { ToolTipBadge } from "../../../Components/ToolTip";
import CanvasPreview from "../../../react/components/CanvasPreview";
import { $ } from "../../../vendor";
import { AiGenerateProgress } from "../GeneratePresentation/Components/AiGenerateProgress";
import SlideAiController from "./SlideAiController";
import { t } from "js/i18n";

const SLIDE_GAP = 20;

const Container = styled.div`
    width: 100%;
    height: 100%;
    background: #444;
    overflow-y: scroll;
    pointer-events: auto;

    &::-webkit-scrollbar-thumb:vertical {
        border-radius: 20px;
        background-color: #666;
        border: 8px 4px 8px 8px solid transparent;
        background-clip: content-box;
    }

    padding: 10px ${SLIDE_GAP}px 30px;
    padding-right: 0px;
`;

const SlidesContainer = styled.div.attrs({ "data-test-id": "slide-ai-ideas-slides" })`
    position: relative;
    grid-area: slides;
    display: flex;
    flex-direction: row;
    gap: ${SLIDE_GAP}px;
    flex-wrap: wrap;
    color: white;
    font-size: 14px;
`;

const ProgressContainer = styled.div`
    position: relative;
    overflow: hidden;
    height: 100%;
`;

const SlideCategory = styled.div`
    display: flex;
    gap: 10px;
    flex-direction: column;
`;

const CategoryLabel = styled.div`
    display: flex;
    font-weight: bold;
    padding: 5px 0px 5px;
    align-items: center;
    justify-content: center;
    color: white;
    text-transform: uppercase;
`;

class SlideAiIdeasList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            slideWidth: props.slideWidth ?? 50
        };

        this.hasBeenUnmounted = false;

        this.ref = React.createRef();
    }

    componentDidMount() {
        if (!this.props.slideWidth) {
            this.setState({
                slideWidth: (this.ref.current.getBoundingClientRect().width - SLIDE_GAP * 4 - 30) / 3
            });

            $(window).on("resize", event => {
                this.setState({
                    slideWidth: (this.ref.current.getBoundingClientRect().width - SLIDE_GAP * 4 - 30) / 3
                });
            });
        }
    }

    shouldComponentUpdate(nextProps) {
        return !nextProps.canvasController?.canvas?.isAnimating;
    }

    render() {
        const { slideWidth } = this.state;
        const { onSelect, slideCategories, canvasController, isGenerating } = this.props;

        if (isGenerating || !slideCategories || slideCategories.length === 0) {
            return (
                <ProgressContainer ref={this.ref}>
                    <AiGenerateProgress label={t("Generating ideas...")} fontSize={18} />
                </ProgressContainer>
            );
        }

        return (
            <Container ref={this.ref}>
                <SlidesContainer>
                    {slideCategories.map((category, idx) => (
                        <SlideCategory key={idx}>
                            <CategoryLabel>
                                {t("{{category}} slides", { category: category.slideCategory.replace("_", " ").toTitleCase() })}&nbsp;&nbsp;
                                <ToolTipBadge>
                                    <strong>
                                        {t("Why did we suggest {{category}} slides? ({{confidence}}% match)", {
                                            category: category.slideCategory.replace("_", " ").toTitleCase(),
                                            confidence: category.slideConfidence
                                        })}
                                    </strong>
                                    <br />
                                    <br />
                                    {category.slideReasoning}
                                </ToolTipBadge>
                            </CategoryLabel>
                            {
                                category.models.map((model, idx) => (
                                    <CanvasPreview
                                        key={idx}
                                        theme={canvasController?.canvas?.getTheme()}
                                        position={null}
                                        slideModel={model}
                                        scale={slideWidth / 1280}
                                        outlineColor="#555"
                                        onClick={() => onSelect(model)}
                                    />
                                ))
                            }
                        </SlideCategory>
                    ))}
                </SlidesContainer>
            </Container>
        );
    }
}

export default SlideAiController.withState(SlideAiIdeasList);
